<template>
  <div class="tpass-warp tpassDetailReturnHome tpReceiptRecord bg-white">
    <loading :show="apiLoading" :isTpass="true"></loading>
    <t-pass-header
      :title="'收據'"
      :routerUrl="'viewclose://'"
      :isRouterAppView="true"
    ></t-pass-header>
    <div class="tab-container">
      <!-- <b-tabs fill pills nav-class="tpass-tabs"> -->
      <!-- <b-tab title="發票" @click="goEInvoice()"> </b-tab>
        <b-tab title="收據" @click="queryReceipt()" :active="changeTab === '2'"> -->
      <div class="tab-header">
        <span class="px-16px">
          您已歸戶 <font>{{ detailData.length }}</font
          >張收據
        </span>
        <router-link
          class="text-underline"
          :to="{
            name: 'taipeiPassAppReceiptReturnHome',
            params: { receiptToken: this.receiptToken },
          }"
          >歸戶
        </router-link>
        <!-- <a class="text-underline" href="">歸戶</a> -->
        <div v-if="isConsole" class="console">
          <!-- <div>url-{{ this.$route.fullPath }}</div> -->
          <!-- <div>res結果{{ receiptToken }}</div> -->
          <!-- <div>$route.params === {{ $route.params }}</div>
          <div>query-{{ this.$route.query }}</div> -->
           <div>目前get token{{ token }}</div>
           <!--   <div>api 結果{{ token }}</div> -->
        </div>
      </div>
      <div class="tab-select bg-white border-bottom-gray-2px">
        <div class="col-4 tab-select-item2 text-center" @click="selectEvent(monthOptions, 'M')">
          {{ selectMonthText }} <em class="fas fa-chevron-down tab-select-down"></em>
        </div>
        <div class="col-8 tab-select-item2" @click="selectEvent(statusOptions, 'S')">
          {{ selectStatusText }} <em class="fas fa-chevron-down tab-select-down"></em>
        </div>
      </div>
      <template v-if="monthDetailList.length === 0">
        <div class="empty-receipt text-center">
          <img
            src="@/assets/images/07.png"
            srcset="@/assets/images/07@2x.png 2x,@/assets/images/07@3x.png 3x"
          />
          <!-- <img src="@/assets/images/receipt.png" alt="empty-receipt" /> -->
          <h4 class="color-primary title">無紀錄</h4>
          <p class="color-gray">目前無收據紀錄</p>
        </div>
      </template>
      <template v-else>
        <div class="py-4">
          <div class="tab-months" v-for="(item, index) in monthDetailList" :key="`${index}`">
            <div class="month">
              <h5 class="monthText">{{ item[0] }}</h5>
              <div
                class="date-content d-flex"
                v-for="(subItem, subindex) in item[1]"
                :key="`${subindex}`"
                @click="openTPassDetailContent(subItem, 'getTPassDetailContent')"
              >
                <div class="date-title">{{ subItem.rpGetDate }}日</div>
                <div class="date-text">
                  <article class="date-text-content">
                    <div class="date-text-item single-ellipsis">
                      {{ subItem.piName }}
                    </div>
                    <div class="date-text-item text-light-gray-1">
                      {{ subItem.rpPublicNo }}
                    </div>
                    <div class="date-text-item">${{ subItem.rpRealAmt | currencyFormat }}</div>
                  </article>
                  <div class="d-flex flex-column">
                    <div class="text-center">
                      <img
                        v-if="subItem.rpStatus === '1'"
                        src="@/assets/images/valid.png"
                        alt="valid"
                      />
                      <img
                        v-if="subItem.rpStatus === '9'"
                        src="@/assets/images/void.png"
                        alt="void"
                      />
                    </div>

                    <div
                      class="color-primary text-center mt-10px"
                      :class="subItem.rpStatus === '1' ? 'color-primary' : 'color-black'"
                    >
                      {{ subItem.rpStatus === '1' ? '有效' : '作廢' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- </b-tab> -->
      <!-- </b-tabs> -->
    </div>

    <!-- 下拉選單 -->

    <select-modal
      :title="selectTitle"
      :selectList="selectList"
      :filterType="filterType"
      :monthActiveIdx="monthActiveIdx"
      :statusActiveIdx="statusActiveIdx"
      :isIOS="isIOS"
      @changeSelectValue="changeSelectValue"
    ></select-modal>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'TpassReceiptRecord',

  mixins: [CommonApiMixin, ApiMixin],

  data() {
    return {
      detailData: [],
      reqData: {},
      apiLoading: false,
      token: null,

      selectList: [],
      selectTitle: '請選擇區間',
      selectMonthText: '近6個月',
      selectMonth: '6',
      monthOptions: [
        {
          text: '近3個月',
          value: '3',
        },
        {
          text: '近6個月',
          value: '6',
        },
        {
          text: '近1年',
          value: '12',
        },
      ],
      monthActiveIdx: 1,
      statusActiveIdx: 1,
      selectStatusText: '有效',
      selectStatus: '1',
      statusOptions: [
        {
          text: '所有狀態',
          value: '',
        },
        {
          text: '有效',
          value: '1',
        },
        {
          text: '作廢',
          value: '9',
        },
      ],
      receiptStart: this.$moment().local().subtract(3, 'months').format('yyyy-MM-DD'),
      receiptEnd: this.$moment().local().format('yyyy-MM-DD'),
      monthDetailList: [],
      isShowDetailsAll: true,
      changeTab: '2',
      filterType: '', // 查詢條件類別M:月 S:狀態
      receiptToken: '',
      isConsole: false,
      isIOS: false, // 是否為ios
    };
  },

  created() {
    const sUserAgent = navigator.userAgent; // 定義使用者標籤資訊
    // ios
    this.isIOS = !!sUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    console.log('this.$route.query', this.$route);
    this.token = this.$route.query.token ?? '';
    this.receiptToken = this.$route.query.receiptToken ?? '';
    if (this.receiptToken) {
      this.queryReceipt();
    } else {
      this.getReceiptToken();
    }
    this.setTPassToken(this.token);
  },

  methods: {
    ...mapMutations('tPassToken', ['setTPassToken']),
    viewClose() {
      window.location = `viewclose://`;
    },

    goEInvoice() {
      const EInvoiceUrl = `${process.env.VUE_APP_TPASS_INVOICE_URL}/eInvoice/invoiceList?token=${this.token}`;
      console.log('EInvoiceUrl', EInvoiceUrl);
      window.location.href = EInvoiceUrl;
    },

    // 已歸戶收據 API
    QueryTaipeiPass(data) {
      this.apiLoading = true;
      const url = '/GovEReceipt/tpassService/receiptRecordDataSource';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'QueryTaipeiPass');
    },

    // 利用台北通token，去取得receiptToken
    getReceiptToken() {
      this.apiLoading = true;
      const url = '/GovEReceipt/tpassService/gTokenToRToken';
      const method = 'post';
      this.axiosServiceSend({ grantToken: this.token }, url, method, 'getReceiptToken');
    },

    // 已歸戶收據 取選單值並打API
    queryReceipt() {
      this.receiptStart = this.getReceiptStart(this.selectMonth);
      const reqData = {
        startDate: this.receiptStart,
        endDate: this.receiptEnd,
        status: this.selectStatus,
        receiptToken: this.receiptToken,
      };
      this.QueryTaipeiPass(reqData);
    },

    getReceiptStart(value) {
      const type = value === '12' ? 'years' : 'months';
      return this.startDate(parseInt(value === '12' ? '1' : value, 10), type);
    },

    startDate(num, type) {
      return this.$moment().local().subtract(num, type).format('yyyy-MM-DD');
    },

    // 已歸戶收據 分群組
    groupBy(arr, prop) {
      const map = new Map(Array.from(arr, (obj) => [obj[prop], []]));
      arr.forEach((obj) => map.get(obj[prop]).push(obj));
      return Array.from(map);
    },

    // 已歸戶收據 開內頁明細
    openTPassDetailContent(subItem) {
      this.$router.push({
        name: 'taipeiPassAppReceiptDetail',
        params: {
          rpPublicNo: subItem.rpPublicNo,
          rpPublicRandomCode: subItem.rpPublicRandomCode,
          token: this.token,
          isRecord: true,
          receiptToken: this.receiptToken,
        },
      });
    },

    selectEvent(options, filterType) {
      this.$bvModal.show('modal-select');
      this.selectTitle = `請選擇${filterType === 'S' ? '狀態' : '區間'}`;
      this.selectList = options;
      this.filterType = filterType;
    },
    changeSelectValue(data, type, index) {
      if (type === 'M') {
        this.selectMonth = data.value;
        this.selectMonthText = data.text;
        this.monthActiveIdx = index;
      } else if (type === 'S') {
        this.selectStatus = data.value;
        this.selectStatusText = data.text;
        this.statusActiveIdx = index;
      }
      this.queryReceipt();
      this.$bvModal.hide('modal-select');
    },
    success(type, result) {
      switch (type) {
        case 'getReceiptToken':
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          this.receiptToken = result.data.object;
          if (result.data.object) {
            this.queryReceipt();
          }
          if (!this.receiptToken) {
            // this.viewClose();
          }
          break;
        case 'QueryTaipeiPass':
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          this.detailData = result.data.object;
          if (result.data.object.length >= 0) {
            this.detailData.forEach((item) => {
              const data = item;
              data.rpMonth = this.$moment(item.rpDate).format('yyyy年MM月');
              data.rpGetDate = this.$moment(item.rpDate).format('DD');
            });
            this.monthDetailList = this.groupBy(this.detailData, 'rpMonth');
          }
          break;
        default:
          break;
      }
    },
    fail(type, err) {
      switch (type) {
        case 'getReceiptToken':
          if (err) {
            // this.viewClose();
          }
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-link {
  padding: 1rem;
}
</style>
